import src from "IMAGE";
export default { src, width: 540, height: 540, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAQ0lEQVR42q3OMQ5AERBFUf+TEHRWpbQEQWcHNu/qRJQmOdVM5j0hXo5EgMJ3Li0KBioi9H5gkNHRkG5fVsQPD/eu+QS7XQNg1D3DjwAAAABJRU5ErkJggg=="};
